import { Button } from "primereact/button";
import { useForm } from 'react-hook-form';

import { JVInput } from "../../shared/JVInput";
import { Fetch } from "../../shared/Fetch";
import { JVDate } from "../../shared/JVDate";
import { IUsersDropdown, ICompanyMastDropdown, IBranchMastDropdown, ITeamsDropdown, ISkillCategoriesDropdown } from "../../models/IDropdown";
import { JVDropdown } from "../../shared/JVDropdown";
import { useEffect, useState } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { JVCheckbox } from "../../shared/JVCheckbox";
import { ILogin } from "../../models/Login";
import { Dropdown } from "primereact/dropdown";
import { MultiSelect } from "primereact/multiselect";
import { TaxTerm } from "../../models/FDropdown";
import { JVMultiselect } from "../../shared/JVMultiselect";


export interface IFilterPurchase {
    POorStart_Date?: string | null,
    From_Date?: Date | null,
    To_Date?: Date | null,
    Req_ID?: number | null | string,
    Consultant_Name?: string | null,
    End_Client?: string | null,
    Vendor_Company_Name?: string | null,
    Sub_Vendor_Company?: string | null,
    Company?: number | null,
    CompanyType?: string | null,
    Branch?: number[] | null,
    Team_Name?: number | null,
    SM?: number | null,
    Recruiter?: number | null,
    Status?: string | null,
    POStatus?: string[] | null,
    s_User_Status?: boolean | null,
    r_User_Status?: boolean | null,
    req_Category?: number | null,
    tax_Term?: string | null,

}

export const EmptyFilterPurchase = {
    POorStart_Date: null,
    From_Date: null,
    To_Date: null,
    Req_ID: "",
    Consultant_Name: "",
    End_Client: "",
    Vendor_Company_Name: "",
    Sub_Vendor_Company: "",
    Company: null,
    CompanyType: null,
    Branch: null,
    Team_Name: null,
    SM: null,
    Recruiter: null,
    Status: null,
    s_User_Status: null,
    r_User_Status: null,
    req_Category: null,
    tax_Term: null,
}


const schema = yup.object({
    POorStart_Date: yup.string().nullable(),
    From_Date: yup.date().nullable(),
    To_Date: yup.date().nullable(),
    Req_ID: yup.string().nullable(),
    Consultant_Name: yup.string().nullable(),
    End_Client: yup.string().nullable(),
    Vendor_Company_Name: yup.string().nullable(),
    Sub_Vendor_Company: yup.string().nullable(),
    Company: yup.string().nullable(),
    CompanyType: yup.string().nullable(),
    Branch: yup.string().nullable(),
    Team_Name: yup.number().nullable(),
    SM: yup.number().nullable(),
    Recruiter: yup.string().nullable(),
    //Status: yup.string().nullable(),
    req_Category: yup.number().nullable(),
    s_User_Status: yup.bool().nullable(),
    r_User_Status: yup.bool().nullable(),
});

interface Iprops {
    filters: IFilterPurchase,
    setFilters: (filters: IFilterPurchase) => void,

}
export const Filter = (props: Iprops) => {

    const [po, setPo] = useState<Array<any>>();
    const [company, setCompany] = useState<Array<ICompanyMastDropdown>>();
    const [type, setType] = useState<Array<any>>();
    const [branch, setBranch] = useState<Array<IBranchMastDropdown>>();
    const [team, setTeam] = useState<Array<ITeamsDropdown>>();
    const [sm, setSM] = useState<Array<IUsersDropdown>>();
    const [recruiters, setRecruiters] = useState<Array<IUsersDropdown>>();
    const [status, setStatus] = useState<Array<any>>();
    const [skillCategories, setSkillCategories] = useState<Array<ISkillCategoriesDropdown>>();
    const [selectedSm, setselectedSm] = useState<any | null>(null);
    const [selectedRecruiter, setSelectedRecruiter] = useState<any | null>(null);
    const [selectedBranch, setSelectedBranch] = useState<Array<number>>([]);
    const [selectedStatus, setSelectedStatus] = useState<Array<{ load_Type: string }>>();


    let _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _roles.push(role.role_ID);
    });


    const { control, handleSubmit, watch, formState: { errors }, reset } = useForm<IFilterPurchase>({
        resolver: yupResolver(schema),
        defaultValues: props.filters,
        shouldFocusError: false
    });

    const sales_Status: { label: string, status: boolean | null }[] = [
        { label: "-- SELECT --", status: null },
        { label: 'Active', status: true },
        { label: 'Inactive', status: false },
    ]
    const recruiters_Status: { label: string, status: boolean | null }[] = [
        { label: "-- SELECT --", status: null },
        { label: 'Active', status: true },
        { label: 'Inactive', status: false },
    ]

    const loadSm = async (branch: number[] | null | undefined, company: number | null | undefined, team: number | null | undefined) => {
        let queryParameter = null;
        if (team != 0 && team != null) {
            queryParameter = `team_ID=${team}`;
        } else if (branch && branch.length > 0 && branch[0] != 0) {
            queryParameter = branch.map(b => `branch_ID=${b}`).join("&");

        } else if (company != 0 && company != null) {
            queryParameter = `company_ID=${company}`;
        }

        const response = await Fetch("Dropdown/filterUsersListss", "GET", null, queryParameter, null);
        if (response) {
            const data: Array<IUsersDropdown> = await response.json();
            const emptyData = {
                login_ID: 0,
                user_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setSM(data);
        }
    }

    const loadStatus = async () => {
        const data = [
            {
                load_Type: "-- SELECT --"
            },
            {
                load_Type: "Joined"
            },
            {
                load_Type: "To Join"
            },
            {
                load_Type: "Ended"
            },
            {
                load_Type: "Fizzled"
            },
        ]
        setStatus(data);
    }

    const loadTeam = async (branch: number[] | null | undefined, company: number | null | undefined, type?: string) => {
        let queryParameter = null;
        if (branch && branch.length > 0 && branch[0] != 0) {
            queryParameter = branch.map(b => `branch_ID=${b}`).join("&");
        } else if (company != 0 && company != null) {
            queryParameter = `company_ID=${company}`;
        }

        if (type && type != "" && type != "-- SELECT --") {
            if (type === "sales") queryParameter = "user_Type=sales&" + queryParameter;
            if (type === "recruiter") queryParameter = "user_Type=recruiter&" + queryParameter;
        }

        const response = await Fetch("Dropdown/filterTeamsList", "GET", null, queryParameter, null);
        if (response) {
            const data: Array<ITeamsDropdown> = await response.json();
            const emptyData = {
                team_ID: 0,
                team_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setTeam(data);
        }
    }

    const loadBranch = async (company?: number | null | undefined) => {
        let queryParam = company ? `company_id=${company}` : null;
        const response = await Fetch("Dropdown/filterBranchList", "GET", null, queryParam, null);
        if (response) {
            const data: Array<IBranchMastDropdown> = await response.json();
            const emptyData = {
                branch_ID: 0,
                branchName: "-- SELECT --",
                company_ID: 0
            };
            data.unshift(emptyData);
            setBranch(data);
        }
    }

    const loadType = () => {

        const data = [
            {
                type_Name: "-- SELECT --"
            },
            {
                type_Name: "sales"
            },
            {
                type_Name: "recruiter"
            }]
        setType(data);
    }

    const loadCompany = async () => {
        const response = await Fetch("Dropdown/reqCompanyList", "GET", null, null, null);
        if (response) {
            const data: Array<ICompanyMastDropdown> = await response.json();
            const emptyData = {
                company_ID: 0,
                company_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setCompany(data);
        }
    }

    const loadPo = async () => {
        const data = [
            {
                po_Type: "-- SELECT --"
            },
            {
                po_Type: "Start Date"
            },
            {
                po_Type: "PO Date"
            },
            {
                po_Type: "End Date"
            }
        ]

        setPo(data);
    }

    const loadRecruiters = async (branch: number[] | null | undefined, company: number | null | undefined, team: number | null | undefined) => {
        let queryParameter = null;
        if (team != 0 && team != null) {
            queryParameter = `team_ID=${team}`;
        } else if (branch && branch.length > 0 && branch[0] != 0) {
            queryParameter = branch.map(b => `branch_ID=${b}`).join("&");
        } else if (company != 0 && company != null) {
            queryParameter = `company_ID=${company}`;
        }

        const response = await Fetch("Dropdown/filterUsersListss", "GET", null, `user_Type=recruiter&${queryParameter}`, null);
        if (response) {
            const data: Array<IUsersDropdown> = await response.json();
            const emptyData = {
                login_ID: 0,
                user_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setRecruiters(data);
        }
    }

    const loadSkillCategories = async () => {
        const response = await Fetch("Dropdown/skillsCategories", "GET", null, null, null);
        if (response) {
            const data: Array<ISkillCategoriesDropdown> = await response.json();
            const emptyData = {
                req_CategoryID: 0,
                req_CategoryName: "-- SELECT --",
            };
            data.unshift(emptyData);
            setSkillCategories(data);
        }
    };

    useEffect(() => {
        const subscription = watch((value, { name, type }) => {
            if (name === "CompanyType") {
                if (value.CompanyType === "recruiter" && value.CompanyType != null) {

                    loadTeam(control._formValues.Branch, control._formValues.Company, "recruiter");
                } else if (value.CompanyType === "sales" && value.CompanyType != null) {

                    loadTeam(control._formValues.Branch, control._formValues.Company, "sales");
                } else {

                    if (value.CompanyType != null) {
                        loadTeam(control._formValues.Branch, control._formValues.Company, "");
                    }
                }
            }

            if (name === "Company") {
                if (value.Company != 0 && value.Company != null) {
                    loadTeam([], value.Company);
                    loadSm([], value.Company, 0);
                    loadBranch(value.Company);
                } else {
                    if (value.Company === 0 && value.Company != null) {
                        loadBranch();
                        loadTeam(control._formValues.Branch, value.Company);
                        loadRecruiters(control._formValues.Branch, value.Company, control._formValues.Team_Name);
                        loadSm(control._formValues.Branch, value.Company, control._formValues.Team_Name);
                    }
                }
            }

            if (name === "Branch") {
                if (selectedBranch.length > 0 && value.Branch != null) {
                    //loadTeam(value.Branch, 0);
                    // loadSm(value.Branch, 0, 0);
                    // loadRecruiters(value.Branch, 0, 0);
                } else {
                    if (selectedBranch.length == 0 && value.Branch != null) {
                        loadTeam(selectedBranch, control._formValues.Company);
                        loadRecruiters(selectedBranch, control._formValues.Company, control._formValues.Team_Name);
                        loadSm(selectedBranch, control._formValues.Company, control._formValues.Team_Name);
                    }
                }
            }

            if (name === "Team_Name") {
                if (value.Team_Name != 0 && value.Team_Name != null) {
                    loadSm([], 0, value.Team_Name);
                    loadRecruiters([], 0, value.Team_Name);
                } else {
                    if (value.Team_Name === 0 && value.Team_Name != null) {
                        loadRecruiters(control._formValues.Branch, control._formValues.Company, value.Team_Name);
                        loadSm(control._formValues.Branch, control._formValues.Company, value.Team_Name);
                    }
                }
            }
        });

        return () => subscription.unsubscribe();
    }, [watch]);

    useEffect(() => {
        loadSkillCategories();
        loadStatus();
        loadSm([], 0, 0);
        loadTeam([], 0);
        loadType();
        loadBranch();
        loadPo();
        loadCompany();
        loadRecruiters([], 0, 0);
    }, []);

    const searchToDB = async (body: IFilterPurchase) => {
        let filterData: any = body;
        if (selectedBranch.length > 0) body.Branch = selectedBranch
        let emptyFilter: any = EmptyFilterPurchase;
        body.SM = selectedSm;
        body.Recruiter = selectedRecruiter;
        for (let key in filterData) {
            if (filterData[key] === "-- SELECT --" || filterData[key] === 0) {
                filterData[key] = emptyFilter[key];
            }
            if (key === "Req_ID") {
                if (filterData["Req_ID"] === "") {
                    filterData["Req_ID"] = null;
                } else {
                    filterData["Req_ID"] = Number(filterData["Req_ID"]);
                }
            }
        }
        body = filterData;
        props.setFilters(body);
    }

    const onClear = () => {
        setselectedSm(null);
        setSelectedRecruiter(null);
        reset(EmptyFilterPurchase)
        loadStatus();
        loadSm([], 0, 0);
        loadTeam([], 0, "");
        loadType();
        loadBranch();
        loadPo();
        loadCompany();
        loadRecruiters([], 0, 0);
        setSelectedBranch([])
    }

    function onSubmit(data: IFilterPurchase) {
        data.POStatus = selectedStatus && selectedStatus.length > 0 ? selectedStatus.map(el => el.load_Type) : null;
        searchToDB(data);
    }

    useEffect(() => {
        if (selectedBranch.length > 0) {
            console.log("Selected Branches:", selectedBranch);
            loadTeam(selectedBranch, 0); // Assuming loadTeam takes a single branch
            loadRecruiters(selectedBranch, 0, 0);
            // Pass the entire array
            loadSm(selectedBranch, 0, 0);

        }

    }, [selectedBranch]);

    return (

        // <Dialog visible={props.open} style={{ width: '80vw' }} header="Search Requirement" modal className="p-fluid" onHide={onHide}>
        <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">

            <JVDropdown column={6} label="PO/Start Date " control={control} name="POorStart_Date" options={po} optionLabel="po_Type" optionValue="po_Type" placeholder="Select PO " />
            <JVDate maxDate={new Date} column={6} label="From Date" control={control} name="From_Date" />
            <JVDate maxDate={new Date} column={6} label="To Date" control={control} name="To_Date" />
            {!(_roles.includes(30) || _roles.includes(31)) && <><JVInput column={6} label="Req Id" control={control} name="Req_ID" />
                <JVInput column={6} label="Consultant Name/Email" type="text" control={control} name="Consultant_Name" />
                {!(_roles.includes(3) || _roles.includes(4) || _roles.includes(21)) && <JVInput column={6} label="End Client" type="text" control={control} name="End_Client" />}

                {!(_roles.includes(3) || _roles.includes(4) || _roles.includes(21)) && <JVInput column={6} label="Prime Vendor" control={control} name="Vendor_Company_Name" />}
                <JVInput column={6} label="Sub Vendor " type="text" control={control} name="Sub_Vendor_Company" />
                <JVDropdown column={6} label="Type" control={control} name="CompanyType" options={type} optionLabel="type_Name" optionValue="type_Name" placeholder="Select Type" />
                <JVDropdown column={6} label="Company Name " control={control} name="Company" options={company} optionLabel="company_Name" optionValue="company_ID" placeholder="Select Company Name" />
                {/* <JVDropdown column={6} label="Branch " control={control} name="Branch" options={branch} optionLabel="branchName" optionValue="branch_ID" placeholder="Select Branch " /> */}
                <div className="field col-2 md:col-2">
                    <p>Branch</p>
                    <MultiSelect className="" style={{ height: "37px", marginTop: "-10px" }} value={selectedBranch} onChange={(e) => setSelectedBranch(e.value)} options={branch} optionValue="branch_ID" optionLabel="branchName" display="chip" filter placeholder="Select Branches" />
                </div>
                <JVDropdown column={6} label="Team Name" control={control} name="Team_Name" options={team} optionLabel="team_Name" optionValue="team_ID" placeholder="Select Team Name" />

                {/* <JVDropdown column={6} label="S M" control={control} name="SM" options={sm} optionLabel="user_Name" optionValue="login_ID" placeholder="SM" /> */}
                {/* <JVDropdown column={6} label="Recruiter" control={control} name="Recruiter" options={recruiters} optionLabel="user_Name" optionValue="login_ID" placeholder="Select Recruiter" /> */}
                {/* <JVDropdown column={6} label="Status " control={control} name="Status" options={status} optionLabel="load_Type" optionValue="load_Type" placeholder="Select Status " /> */}
                <JVMultiselect column={6} label="Status " options={status} optionLabel="load_Type" placeholder="Status" value={selectedStatus} onChange={setSelectedStatus} />
                <JVDropdown column={6} label="Sales Status" control={control} name="s_User_Status" options={sales_Status} optionLabel="label" optionValue="status" placeholder="Select User Status" />
                <JVDropdown column={6} label="Recruiters Status" control={control} name="r_User_Status" options={recruiters_Status} optionLabel="label" optionValue="status" placeholder="Select User Status" />
                <JVDropdown column={6} label="Req Category" control={control} name="req_Category" options={skillCategories} optionLabel="req_CategoryName" optionValue="req_CategoryID" placeholder="Select Req Category" />
            </>}
            <div style={{ width: '15%', marginLeft: '10px' }} >
                <label className="" style={{ display: 'block', marginBottom: '8px' }}>Sales Manager</label>
                <Dropdown value={selectedSm} onChange={(e) => {
                    console.log(e);
                    setselectedSm(e.value);
                    // loadSm(e.value?.Company,0,0);
                }} options={sm} optionLabel="user_Name" placeholder="Select Sales manager" optionValue="login_ID"
                    filter className="w-full" />

            </div>
            <div style={{ width: '15%', marginLeft: '10px' }} >
                <label className="" style={{ display: 'block', marginBottom: '8px' }}>Recruiter</label>
                <Dropdown value={selectedRecruiter} onChange={(e) => {
                    setSelectedRecruiter(e.value);
                }} options={recruiters} optionLabel="user_Name" placeholder="Select Recruiter" optionValue="login_ID"
                    filter className="w-full" />

            </div>
            <JVDropdown column={6} label="Tax Term" control={control} name="tax_Term" options={TaxTerm} optionLabel="name" optionValue="name" placeholder="--Select TaxTerm--" />
            <div style={{ margin: '10px 0', width: '100%' }}></div>

            <div className="col-12 md:col-12" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '10px', marginTop: '10px' }}>
                <Button className="field col-12 md:col-6" label="SEARCH" type="submit"></Button>
                <Button className="field col-12 md:col-6 p-button-outlined" label="CLEAR" onClick={onClear} type="button"></Button>
            </div>
        </form>

    )
}